
import { defineComponent } from 'vue';
import { mapActions } from 'pinia';
import {
  MY_BOOKINGS_REDIRECTION_PAGES,
} from '@white-label-configuration/constants';
import {
  SearchBoxParking,
  SearchBoxLounges,
  SearchBoxTimeslot
} from 'ecommerce/feature-search-form';
import { IconMessage } from 'ui-shared-components';
import { getAppHeroProduct } from '@white-label-helper/get-app-hero-product';
import type {
  SearchBoxLoungesComponent,
  SearchLoungeForm,
} from '@white-label-types/lounges-component';
import { trackSearchInitiated } from '@white-label-helper/ga-tracking';

import IconCheck from '@white-label-icon/icon-check';
import { getFeatureFlag } from '@white-label-plugin/launch-darkly';
import type VueI18n from 'vue-i18n';
import { getAppVariable } from '@white-label-helper/get-app-variable';
import { useSearchBoxStore } from '@white-label-store/search-box';
import { pushToRouter } from '@white-label-helper/router';

export default defineComponent({
  components: {
    IconCheck,
    IconMessage,
    SearchBoxLounges,
    SearchBoxParking,
    SearchBoxTimeslot,
  },

  data() {
    return {
      discount: '',
      initParams: {} as { [key: string]: string },
      discountFromQuery: '' as string,
      isParkingProduct: getAppHeroProduct('lounges') === 'parking',
      isLoungesProduct: getAppHeroProduct('parking') === 'lounges',
      isTimeslotProduct: getFeatureFlag('NGQ_11_TimeSlot'),
    };
  },
  computed: {
    pageTitle(): string | VueI18n.TranslateResult {
      return getAppVariable<string | VueI18n.TranslateResult>(
        `page_title[${this.$i18n.locale}]`,
        this.isLoungesProduct ? this.$t('searchBox.loungesTitle') : this.$t('searchBox.title')
      );
    },
  },
  mounted() {
    // TODO Need to delete when dev will moved to hosting, which supports Nuxt middleware
    this.mountedCheckerHelper();
    this.discount = (this.$route.query['discount'] || '') as string;
    trackSearchInitiated(this.$gtm);
  },

  methods: {
    ...mapActions(useSearchBoxStore, ['getSearchBoxParams', 'saveSearchBoxParams']),
    initForm() {
      if (!this.$refs['form']) {
        return;
      }
      const form = this.$refs['form'] as SearchBoxLoungesComponent;
      const initParams: SearchLoungeForm = this.getSearchBoxParams('lounges');
      initParams['discount'] = this.discount;

      if (typeof form.setSearchCriteria !== 'function') {
        return;
      }

      form.setSearchCriteria(initParams);
      this.$nextTick(() => form.pushGTM());
    },

    formUpdate() {
      if (this.$refs['form']) {
        const params = (
          this.$refs['form'] as SearchBoxLoungesComponent
        ).getSearchCriteria();

        this.saveSearchBoxParams({
          id: 'lounges',
          data: params,
        });
      }
    },

    submit({
      error,
      searchCriteriaSerialized,
    }: {
      error: boolean;
      searchCriteriaSerialized: { [key: string]: string };
    }) {
      if (!error) {
        localStorage.setItem('searchCriteriaSerialized', JSON.stringify(searchCriteriaSerialized) ?? '{}');
        pushToRouter({ path: MY_BOOKINGS_REDIRECTION_PAGES.choose, query: searchCriteriaSerialized });
      }
    },
  },
});
